<span [id]="program().id">{{ program().name() }}</span>